import flatpickr from 'flatpickr';

flatpickr.l10ns["default"].rangeSeparator = ' thru ';
flatpickr.l10ns["default"].weekdays.shorthand = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
